import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
   border: 0;
   background-color: var(--heading-text-color-alt);
   color: var(--text-color-inverted);
   box-shadow: 3px 3px 5px var(--shadow-color);
   font-weight: bold;
   font-size: 1.2rem;
   padding: 20px;

   :focus {
      outline: none;
   }

   :hover {
      background-color: var(--text-color-inverted);
      color: var(--heading-text-color-alt);
      cursor: pointer;
   }
`

const Button = ({ text }) => <StyledButton type="button">{text}</StyledButton>

Button.propTypes = {
   text: PropTypes.string,
}

export default Button
